<template>
  <div class="jin-m-grade">
    <ul class="jin-m-grade-warp">
      <li
        v-for="(item, i) in info"
        :key="i"
        class="jin-m-grade-item"
        @click="$router.push({
          path: `/list/resume/${template}?idx=${i}`,
          query: $route.query
        })"
      >
        <p class="name">
          <span>
            {{ item.certificate_name }}
          </span>
          <Icon name="arrow-right" />
        </p>
        <p class="time">{{ item.get_time }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Array,
      default: () => []
    },
    template: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.jin-m {
  &-grade {
    &-item {
      margin-top: 20px;

      .name {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 4px;

        span {
          font-size: 15px;
          color: #3d4351;
          line-height: 18px;
        }

        i {
          font-size: 14px;
          color: #787b8a;
        }
      }

      .time {
        font-size: 11px;
        color: #a0a4b7;
        line-height: 18px;
      }
    }
  }
}
</style>
